// Player detail (ADMIN_UI §3.8). Header + four tabs (overview / preferences /
// send-history-with-credit-replay / pending-jobs-with-cancel). Tab state is
// local — not URL-driven for MVP; revisit if operators want to deep-link a tab.

import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { AsyncState } from '../../components/AsyncState.js';
import { OverviewTab } from '../../components/players/OverviewTab.js';
import { PendingJobsTab } from '../../components/players/PendingJobsTab.js';
import { PlayerHeader } from '../../components/players/PlayerHeader.js';
import { PreferencesTab } from '../../components/players/PreferencesTab.js';
import { SendHistoryTab } from '../../components/players/SendHistoryTab.js';
import { Tabs } from '../../components/ui/tabs.js';
import { getPlayer } from '../../lib/api/players.js';
import { qk } from '../../lib/query-keys.js';

export const Route = createFileRoute('/_authed/players/$playerId')({
  component: PlayerDetailPage,
});

type TabId = 'overview' | 'preferences' | 'send-history' | 'pending-jobs';
const TABS: { id: TabId; label: string }[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'preferences', label: 'Preferences' },
  { id: 'send-history', label: 'Send history' },
  { id: 'pending-jobs', label: 'Pending jobs' },
];

function PlayerDetailPage() {
  const { playerId } = Route.useParams();
  const [tab, setTab] = useState<TabId>('overview');
  const query = useQuery({
    queryKey: qk.players.detail(playerId),
    queryFn: () => getPlayer(playerId),
  });

  return (
    <AsyncState query={query}>
      {(player) => (
        <div>
          <PlayerHeader player={player} />
          <Tabs<TabId> value={tab} onChange={setTab} items={TABS}>
            {tab === 'overview' && <OverviewTab player={player} />}
            {tab === 'preferences' && <PreferencesTab playerId={playerId} />}
            {tab === 'send-history' && <SendHistoryTab playerId={playerId} />}
            {tab === 'pending-jobs' && <PendingJobsTab playerId={playerId} />}
          </Tabs>
        </div>
      )}
    </AsyncState>
  );
}
